/**
 * @name Loader
 * @description This components is a Material Design Spin Loader like.
 *
 * TODO: Add time for improve the animation without breaking IE11
 *
 * @example
 *
 * <Loader size={24} color="gray" strokeWidth={2}/>
 */

import React from 'react';
import styles from './loader.module.scss';

type Props = {
  size: number;
  strokeWidth: number;
  color: string;
};

export class Loader extends React.Component<Props> {
  static defaultProps = {
    size: 24,
    strokeWidth: 2,
    color: '#616161',
  };

  render() {
    const { size, strokeWidth, color } = this.props;

    const position = size / 2;
    const radius = position - strokeWidth;
    const style = { width: `${size}px`, height: `${size}px` };

    return (
      <div className={styles.loader} style={style}>
        <svg
          className={styles.circular}
          style={style}
          viewBox={`0 0 ${size} ${size}`}
        >
          <circle
            className={styles.path}
            cx={position}
            cy={position}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
          />
        </svg>
      </div>
    );
  }
}
